<template>
  <v-container>
    <v-row class="mt-12">
      <v-col class="mt-12" :class="{'mb-12':$vuetify.breakpoint.md}">
        <div
          :class="{
            'display-4': $vuetify.breakpoint.mdAndUp,
            'display-2': $vuetify.breakpoint.smAndDown,
          }"
          class="font-weight-bold text-center"
        >
          Bienvenido
          <span v-if="!isWhiteBrandDomain() && (!userData.available_features || !userData.available_features.feature_marca_blanca)">
            a Inmatic
          </span>
        </div>
        <div
          :class="{
            headline: $vuetify.breakpoint.mdAndUp,
            'subtitle-2': $vuetify.breakpoint.smAndDown,
          }"
          class="mt-5 text-center"
        >
          <slot>
            Vamos a configurar su cuenta siguiendo unos sencillos pasos.
          </slot>
        </div>
        <div class="text-center mt-10">
          <v-row>
            <v-col cols="12" offset="12" offset-md="12" >
              <v-btn color="secondary" @click="nextStep">Empezar</v-btn>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Landing",
  data() {
    return {
      watchDemo: false,
      domain: window.location.origin,
      whiteBrandDomains: [
          'docuxtract.docunecta.com',
          'gscan.glasof.com',
          'portal.oxigendc.com',
          'app.novantiaeconomistas.es',
          'app.gestoriamoro.com'
      ],
    };
  },
  computed: {
    ...mapGetters({
      userData: 'me/userData',
      got_feature:'got_feature',
    }),
  },
  methods: {
    nextStep() {
      this.$emit("nextStep");
    },
    toggleWatchDemo() {
      this.watchDemo = !this.watchDemo;
    },
    isWhiteBrandDomain() {
      if (this.whiteBrandDomains.some(d => this.domain.includes(d))) {
        return true;
      }
      return false;
    },
  },
};
</script>

